import { getConfig, isServerSide, trialCheckoutRoutes } from "@jti/fe-common";
import { BrowserStorage } from "@jti/rest-api";

export const NAVIGATE_AFTER_REFRESH_FLAG = "moveBackToTrialProducts";

const storage = new BrowserStorage();

const STORAGE_ANONYMOUS_CART_KEY = "anonymousCartId";
const STORAGE_ANONYMOUS_CART_FREE_TRIAL_KEY = "anonymousFreeTrialCartId";
const FREE_TRIAL_REDIRECT = "freeTrialRedirect";

const getStorageName = (isFreeTrial: boolean, storeName: string) => {
  return !isFreeTrial ? storeName + "_" + STORAGE_ANONYMOUS_CART_KEY : STORAGE_ANONYMOUS_CART_FREE_TRIAL_KEY;
};

export const getAnonymousCartId = (storeName: string, isFreeTrial = false): string | undefined =>
  storage.get<string | undefined>(getStorageName(isFreeTrial, storeName), undefined);

export const setAnonymousCartId = (cartId: string, storeName: string, isFreeTrial = false): void => {
  storage.set<string>(getStorageName(isFreeTrial, storeName), cartId);
};

export const deleteAnonymousCart = (storeName: string, isFreeTrial = false): void => {
  storage.delete(getStorageName(isFreeTrial, storeName));
};

export const setFreeTrialRedirect = (): void => {
  if (isServerSide()) return;
  window.localStorage.setItem(FREE_TRIAL_REDIRECT, "true");
};

export const isFreeTrialRedirect = (): boolean => {
  if (isServerSide()) return false;
  return window.localStorage.getItem(FREE_TRIAL_REDIRECT) === "true";
};

export const clearFreeTrialRedirect = (): void => {
  if (isServerSide()) return;
  window.localStorage.removeItem(FREE_TRIAL_REDIRECT);
};

export const removeFreeTrialRefreshProtection = (): void => {
  if (isServerSide()) return;
  window.localStorage.removeItem(NAVIGATE_AFTER_REFRESH_FLAG);
};

export const redirectToCartPage = (): string | undefined => {
  if (isServerSide()) return undefined;
  return (window.location.href = getConfig().CART_CHECKOUT_PAGE_URL);
};

export const redirectToTrialCheckoutPage = (): void => {
  if (isServerSide()) return;
  const { CART_CHECKOUT_PAGE_URL } = getConfig();

  const CART_CHECKOUT_PAGE_URL_WITHOUT_HASH = CART_CHECKOUT_PAGE_URL?.replace(/#(.)*$/, "");

  window.location.href = `${CART_CHECKOUT_PAGE_URL_WITHOUT_HASH}#${trialCheckoutRoutes.shipping}`;
};

export const redirectToAuthWithBack = (resolvedAuthHref: string): string | undefined => {
  if (isServerSide()) return undefined;

  return (window.location.href = resolvedAuthHref);
};

export const redirectToTrialAuthWithBack = (resolvedAuthHref: string): string | undefined => {
  if (isServerSide()) return undefined;

  return (window.location.href = resolvedAuthHref);
};
